<script lang="ts" setup>
import { ref } from 'vue'

import IconCloseGray from './assets/icon-close.svg'

import { useResizeObserver } from '@/composables/useResizeObserver'
import ABaseIcon from '@/components/atoms/ABaseIcon/index.vue'

/**
 * Props
 */
type Props = {
  width: number
}
const props = defineProps<Props>()

/**
 * Emit
 */
type Emits = {
  close: []
}
const emit = defineEmits<Emits>()

/**
 * Refs
 */
const headerElement = ref(null)
const headerHeight = ref(0)

/**
 * Composables
 */
useResizeObserver(headerElement, (entries) => {
  const entry = entries[0]
  if (!entry) {
    return
  }

  headerHeight.value = entry.borderBoxSize[0].blockSize
})
</script>

<template>
  <div class="panel-container">
    <div
      class="wrapper"
      :style="{ width: `${props.width}px` }"
    >
      <div
        ref="headerElement"
        class="header"
      >
        <slot name="title" />

        <button
          class="button-close"
          @click="() => emit('close')"
        >
          <ABaseIcon :src="IconCloseGray" />
        </button>
      </div>

      <div :style="`height: calc(100% - ${headerHeight}px)`">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel-container {
  position: relative;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 0 4px 0 #00000026;
  transition: min-width 0.3s;

  > .wrapper {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    background-color: #fff;
  }

  > .wrapper > .header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px solid rgb(var(--v-theme-ui-gray1));
  }
}
</style>
